export default __webpack_public_path__ + "static/media/config-approval-illustration.40d02dbf.svg";